import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetItemCharacteristicsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.ItemCharacteristicDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ItemCharacteristicDocumentSortInput> | Types.ItemCharacteristicDocumentSortInput>;
}>;


export type GetItemCharacteristicsQuery = { __typename?: 'Query', itemCharacteristics?: { __typename?: 'ItemCharacteristicsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ItemCharacteristicDocument', itemCharacteristicId: string, name: string, sortOrder: number, onHold: boolean, status: Types.ItemCharacteristicStatus, values: Array<{ __typename?: 'ItemCharacteristicValueDocument', valueId: string, name: string, sortOrder: number, onHold: boolean, status: Types.ItemCharacteristicStatus }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ItemCharacteristicRowFragment = { __typename?: 'ItemCharacteristicDocument', itemCharacteristicId: string, name: string, sortOrder: number, onHold: boolean, status: Types.ItemCharacteristicStatus, values: Array<{ __typename?: 'ItemCharacteristicValueDocument', valueId: string, name: string, sortOrder: number, onHold: boolean, status: Types.ItemCharacteristicStatus }> };

export const ItemCharacteristicRowFragmentDoc = new TypedDocumentString(`
    fragment ItemCharacteristicRow on ItemCharacteristicDocument {
  itemCharacteristicId
  name
  sortOrder
  onHold
  status
  values {
    valueId
    name
    sortOrder
    onHold
    status
  }
}
    `, {"fragmentName":"ItemCharacteristicRow"});
export const GetItemCharacteristicsDocument = new TypedDocumentString(`
    query GetItemCharacteristics($first: Int, $after: String, $where: ItemCharacteristicDocumentFilterInput, $order: [ItemCharacteristicDocumentSortInput!]) {
  itemCharacteristics(first: $first, after: $after, where: $where, order: $order) {
    nodes {
      ...ItemCharacteristicRow
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ItemCharacteristicRow on ItemCharacteristicDocument {
  itemCharacteristicId
  name
  sortOrder
  onHold
  status
  values {
    valueId
    name
    sortOrder
    onHold
    status
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetItemCharacteristics: build.query<GetItemCharacteristicsQuery, GetItemCharacteristicsQueryVariables | void>({
      query: (variables) => ({ document: GetItemCharacteristicsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetItemCharacteristicsQuery, useLazyGetItemCharacteristicsQuery } = injectedRtkApi;
